import type { OrdenationDropdownOption } from '~/components/Filters/OrdenationSelect';
import type { MixpanelProps } from '~/core/service/mixpanel';
import type { FilterApplied } from '~/types/mixpanel';

export { STORAGE_KEYS, type StorageKey } from './storageKeys';

export const appName = 'Pilar Homes';
export const appDescription = 'Imóveis de luxo';
export const siteName = 'PilarHomes';
export const urlPilarHomes = 'https://www.pilarhomes.com.br';
export const urlSouPilar = 'https://www.soupilar.com.br/';
export const mailSouPilar = 'contato@pilarhomes.com.br';
export const pilarFormattedPhone = '(11) 93620-0964';
export const pilarFormattedPhoneWhatsAppLink = `https://pilar.trb.ai/wa/2Th2GxS`;
export const pilarHomesInstagram = 'https://www.instagram.com.br/pilarhomes_';

// Search Suggest constants
export const SEARCH_SUGGEST = {
	MIN_SEARCH_LENGTH: 3,
	TYPING_DEBOUNCE_MS: 350
} as const;
export const filtersAppliedMap = {
	region: 'neighborhood',
	city: 'city',
	macroregion: 'region',
	street: 'address / point of interest',
	point_of_interest: 'address / point of interest',
	condo: 'condo',
	code: 'code'
} as const;
export const defaultOrdenationOptions: OrdenationDropdownOption[] = [
	{
		label: 'Mais Relevantes',
		value: 'default_ordenation',
		sortBy: undefined,
		orderBy: undefined
	},
	{
		label: 'Mais recentes',
		value: 'publication_date_desc',
		sortBy: 'publication_date',
		orderBy: 'desc'
	},
	{
		label: 'Menor preço',
		value: 'asking_price_asc',
		sortBy: 'asking_price',
		orderBy: 'asc'
	},
	{
		label: 'Maior preço',
		value: 'asking_price_desc',
		sortBy: 'asking_price',
		orderBy: 'desc'
	},
	{
		label: 'Menor área útil',
		value: 'area_asc',
		sortBy: 'area',
		orderBy: 'asc'
	},
	{
		label: 'Maior área útil',
		value: 'area_desc',
		sortBy: 'area',
		orderBy: 'desc'
	},
	{
		label: 'Menor valor por m²',
		value: 'area_price_asc',
		sortBy: 'area_price',
		orderBy: 'asc'
	},
	{
		label: 'Maior valor por m²',
		value: 'area_price_desc',
		sortBy: 'area_price',
		orderBy: 'desc'
	},
	{
		label: 'Mais fotos',
		value: 'images_count_desc',
		sortBy: 'images_count',
		orderBy: 'desc'
	},
	{
		label: 'Menos fotos',
		value: 'images_count_asc',
		sortBy: 'images_count',
		orderBy: 'asc'
	}
];

// Note: For convenience helpers, see createSharingUrlsForMessage() and createSharingUrlsForUrl() in utils/index.ts
export const sharingPlatforms = {
	whatsapp: (encodedMessage: string) =>
		`https://api.whatsapp.com/send/?text=${encodedMessage}`,

	twitter: {
		withText: (encodedMessage: string) =>
			`https://twitter.com/share?text=${encodedMessage}`,
		withUrl: (encodedUrl: string) =>
			`https://twitter.com/share?url=${encodedUrl}`
	},

	facebook: {
		withQuote: (encodedMessage: string) =>
			`https://www.facebook.com/sharer/sharer.php?quote=${encodedMessage}`,
		withUrl: (encodedUrl: string) =>
			`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
	},

	email: (encodedMessage: string, subject: string) => {
		const safeMessage = encodedMessage ?? '';
		return `mailto:?subject=${encodeURIComponent(subject)}&body=${safeMessage}`;
	}
} as const;

// Sharing platforms type for better type safety
export type SharingPlatform = keyof typeof sharingPlatforms;
